import { Reveal, Overline } from "@/components/Reveal";
import { Badge } from "@/components/ui/badge";
import { TRAVAUX } from "@/data/content";
import { BadgeCheck, TrendingDown } from "lucide-react";

function TravauxCard({ item, featured }) {
  const Icon = item.icon;
  return (
    <div
      data-testid={`travaux-card-${item.id}`}
      className="group bg-white border border-slate-200 p-8 hover:shadow-xl transition-shadow duration-300 flex flex-col h-full"
    >
      <div className="flex items-start justify-between">
        <div className="h-14 w-14 bg-midnight flex items-center justify-center group-hover:bg-emerald transition-colors duration-300">
          <Icon className="h-7 w-7 text-emerald group-hover:text-white transition-colors duration-300" strokeWidth={1.5} />
        </div>
        {item.cee && (
          <Badge className="rounded-none bg-lime/15 text-lime-600 border border-lime/40 hover:bg-lime/15 font-medium">
            <BadgeCheck className="h-3.5 w-3.5 mr-1" /> Financé par les CEE
          </Badge>
        )}
      </div>

      <h3 className="font-display text-2xl font-bold text-midnight mt-6">{item.title}</h3>
      <p className="mt-3 text-slate-600 font-light text-sm leading-relaxed">{item.description}</p>

      <div className={`mt-5 flex flex-wrap gap-2 ${featured ? "" : ""}`}>
        {item.items.map((t) => (
          <span key={t} className="text-xs bg-slate-100 text-slate-700 px-3 py-1.5">{t}</span>
        ))}
      </div>

      <p className="mt-5 text-sm text-slate-500"><span className="font-medium text-midnight">Bénéfices : </span>{item.benefits}</p>

      <div className="mt-auto pt-6">
        <div className="flex items-center justify-between mb-2">
          <span className="text-xs uppercase tracking-wider text-slate-500 flex items-center gap-1">
            <TrendingDown className="h-3.5 w-3.5 text-lime-600" /> Économie potentielle
          </span>
          <span className="font-display font-bold text-midnight">~{item.economy}%</span>
        </div>
        <div className="h-1.5 w-full bg-slate-100">
          <div className="h-full bg-lime transition-all duration-700" style={{ width: `${item.economy * 2}%`, maxWidth: "100%" }} />
        </div>
      </div>
    </div>
  );
}

export default function Travaux() {
  return (
    <section id="travaux" className="bg-slate-100 py-24 lg:py-32" data-testid="travaux-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal>
          <Overline>Ce que nous finançons</Overline>
          <h2 className="font-display text-3xl lg:text-4xl font-bold tracking-tight text-midnight max-w-2xl">
            Les travaux finançables
          </h2>
          <p className="mt-5 text-slate-600 font-light leading-relaxed max-w-2xl">
            Sept familles de travaux pour réduire durablement vos consommations, avec un potentiel de
            financement CEE sur la majorité des postes.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 mt-14">
          {TRAVAUX.map((item, i) => (
            <Reveal key={item.id} delay={(i % 3) * 0.08} className={item.featured ? "md:col-span-8" : "md:col-span-4"}>
              <TravauxCard item={item} featured={item.featured} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
